<template>
  <div class="modal-background" @click.self="$emit('close')">
    <div class="modal-wrapper" :class="$mq">
      <div class="modal">
        <h1>
          {{ $t(`${content}.warningTitle`) }}
          <span class="close" @click="$emit('close')"
            ><SvgIcon icon="close" fill></SvgIcon
          ></span>
        </h1>
        <p v-html="$t(`${content}.warningText`)" />
      </div>
      <button class="button main" @click="$emit('close')">{{ $t('back') }}</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WarningPrice',
    props: {
      productCDI: {
        type: Boolean
      }
    },
    data() {
      return {
        content: this.productCDI ? 'simulation.product.serviceCDI' : 'simulation.product.service'
      };
    },
    watch: {
      productCDI(newValue) {
        this.content = newValue ? 'simulation.product.serviceCDI' : 'simulation.product.service';
      }
    },
    created() {
      this.content = this.productCDI ? 'simulation.product.serviceCDI' : 'simulation.product.service';
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/components/WarningPrice.vue